// extracted by mini-css-extract-plugin
export default {"container":"ad-block_container__iE4Km","isEmpty":"ad-block_isEmpty__7YGRY","isFluid":"ad-block_isFluid__2WhpN"};